import Vueditor from '@agametov/vueditor'
import VueCountdown from '@xkeshi/vue-countdown'
import VueBootstrap from 'bootstrap-vue'
import moment from 'moment'
import VTooltip from 'v-tooltip'
import ViewUI from "view-design"
import Vue from 'vue'
import VueDateTimePicker from 'vue-bootstrap-datetimepicker'
import VueClipboard from 'vue-clipboard2'
import VueEventCalendar from 'vue-event-calendar'
import VueFullCalendar from 'vue-full-calendar'
import VueGoodTable from 'vue-good-table'
import VueHljs from 'vue-hljs'
import VueInputTag from 'vue-input-tag'
import VueInsProgressBar from 'vue-ins-progress-bar'
import Vmodal from 'vue-js-modal'
import VueMaskedInput from 'vue-maskedinput'
import VueNotification from 'vue-notification'
import VueNVD3 from 'vue-nvd3'
import VueColorpicker from 'vue-pop-colorpicker'
import VueSelect from 'vue-select'
import VueSlider from 'vue-slider-component'
import VueSlimScroll from 'vue-slimscroll'
import VueSparkline from 'vue-sparklines'
import VueSweetalert2 from 'vue-sweetalert2'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueDatepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import VuePanel from './plugins/panel/'
import router from './router'
import store from './store'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// iview
import 'view-design/dist/styles/iview.css'

// use a new library ant-vue-desing
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import './style/main.scss'

import App from './App.vue'
import './components/common'
import i18n from './i18n'
import { ModalDialog, Toast } from './plugins'

import 'croppie/croppie.css'
import locale from "view-design/dist/locale/en-US"
import VueCroppie from 'vue-croppie'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false

Vue.use(ViewUI, { locale });
Vue.use(ViewUI);
Vue.use(Antd)
Vue.use(VueClipboard)
Vue.use(VueBootstrap)
Vue.use(VueCroppie)
Vue.use(VueLazyload)
Vue.use(Vuelidate)
Vue.use(VueNVD3)
Vue.use(VueEventCalendar, { locale: 'en' })
Vue.use(VueSparkline)
Vue.use(Vueditor)
Vue.use(VueHljs)
Vue.use(VueSweetalert2)
Vue.use(VueNotification)
Vue.use(VuePanel)
Vue.use(VueDateTimePicker)
Vue.use(VueGoodTable)
Vue.use(VueFullCalendar)
Vue.use(VueColorpicker)
Vue.use(VueGoogleMaps, {
  load: {
    key: '',
    libraries: 'places'
  }
})
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.use(VueSlimScroll)
Vue.component('v-select', VueSelect)
Vue.component('datepicker', VueDatepicker)
Vue.component('masked-input', VueMaskedInput)
Vue.component('input-tag', VueInputTag)
Vue.component('vue-slider', VueSlider)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component('treeselect', Treeselect)
Vue.use(Toast, { position: 'top-right', duration: 2000 })
Vue.use(ModalDialog)
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
Vue.use(VTooltip)

moment.locale('en', {
  week: {
    dow: 1
  }
})

import Echo from 'laravel-echo'
window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'mdexw123',
  wsHost: 'ts-socket.techstore.asia',
  wssHost: 'ts-socket.techstore.asia',
  wsPort: 6001,
  wssPort: 6001,
  encrypted: true,
  forceTLS: true,
  enabledTransports: ['ws', 'wss']
})

new Vue({
  router,
  store,
  i18n,
  data: {
    appName: process.env.VUE_APP_NAME
  },
  render: h => h(App)
}).$mount('#app')
